import { reduce } from "et3-type-guards";
import { startCase } from "lodash";
import i18n from "../../../../../constants/i18n";
import {
  USER_ADVANCED_EMAILS_HEADERS,
  USER_ADVANCED_HEADERS,
  USER_ADVANCED_QUIZ_HEADERS
} from "../../../../../constants/table-custom-headers/User";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Table from "../../../../../core/et3-table";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import { TUserKeys } from "../../../../../Types";
import React from "react";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import getCorePersonalStore from "../../../../../stores/core/core-personal-store";
import TableChangeForKhattabat from "./TableChangeForKhattabat";

const UserDetailsTable = withLiteObserverAndTheme(() => {
  const userID = getUserAdvancedStore().currentUserId.get();
  const data = getUserAdvancedStore().userData.get(userID);
  const { userIsUnderCsrInvestigation } =
    getUserAdvancedStore().currentUserIsUnderCsrInvestigation.get();
  const arrayOfKeys: TUserKeys[] = [
    "userId",
    "username",
    "deviceId",
    "phoneDetails",
    "gender",
    "status",
    "statusChangeDate",
    "createdOn",
    "createdFrom",
    "lastLogin",
    "deactivatedOn",
    "wasPaying",
    "freemiumSilverUntil",
    "payingSilverUntil",
    "freemiumGoldUntil",
    "payingGoldUntil",
    "freemiumPlatinumUntil",
    "payingPlatinumUntil",
    "payingPowerUntil",
    "freemiumVIPUntil",
    "payingVIPUntil",
    "freemiumPLUSUntil",
    "payingPLUSUntil",
    "payingKhattabatUntil",
    "temporaryBannedCount",
    "warningCount",
    "reportsSent",
    "reportsReceived",
    "referralCode",
    "originCountry",
    "residenceCountry",
    "cityName",
    "selfieVerificationCompletedOn",
    "numberOfVerifiedApprovedPictures",
    "verificationStatus",
    "verificationCode",
    "facebookVerify",
    "smsVerify",
    "emailVerify",
    "appleVerify",
    "emailNotification",
    "pushNotification",
    "loginCount",
    "ipAddress",
    "mobileAppPlatform",
    "mobileAppVersion",
    "userAppLanguage",
    "device_token",
    "religion",
    "subreligion",
    "profilePublicID",
    "khattabaAssigned"
  ];
  const emailData = reduce(() => data.emails, []);
  const dataDefined = arrayOfKeys.map((key) => {
    const value = reduce(() => `${data[key]}`, "");
    if (key === "verificationStatus") {
      return {
        attribut: reduce(() => startCase(key), ""),
        value: value === "no_email" ? "not_verified" : value
      };
    }
    return {
      attribut: startCase(key),
      value
    };
  });
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const shouldBeFlaggedTable =
    userIsUnderCsrInvestigation && !isAnyKhattabaAdmin;
  const userAdvancedTableToShow =
    getUserAdvancedStore().userAdvancedTableToShow.get();
  const shouldShowUserData = userAdvancedTableToShow === "user_data";
  const userQuizData = reduce(
    () => getUserAdvancedStore().userData.get(userID).quizData,
    []
  );

  return (
    <React.Fragment>
      <TableChangeForKhattabat />
      <Et3Table
        columns={
          shouldShowUserData
            ? USER_ADVANCED_HEADERS
            : USER_ADVANCED_QUIZ_HEADERS
        }
        title={i18n.get(
          shouldShowUserData
            ? "USER_ADVANCED_TABLE"
            : "USER_ADVANCED_QUIZ_TABLE"
        )}
        rows={shouldShowUserData ? dataDefined : userQuizData}
        shouldBeFlagged={shouldBeFlaggedTable}
        titleKey={
          shouldShowUserData
            ? "USER_ADVANCED_TABLE"
            : "USER_ADVANCED_QUIZ_TABLE"
        }
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={USER_ADVANCED_EMAILS_HEADERS}
        title={i18n.get("USER_ADVANCED_EMAIL_TABLE")}
        rows={emailData}
        shouldBeFlagged={shouldBeFlaggedTable}
        titleKey={"EMAILS"}
      />
    </React.Fragment>
  );
});
export default UserDetailsTable;
